/**
 * Used by Request Payment Button, Apple Pay, ...
 *
 * @type []{{amount: number, id: string, label: string, detail: string}}
 */
export const SHIPPING_OPTIONS = [
  {
    id: 'free-shipping',
    label: 'Free Shipping',
    detail: 'USPS First Class · 2-4 business days',
    amount: 0,
  },
];

export default SHIPPING_OPTIONS;
